import type { ItemContent } from '~/types/delivery'

/**
 * The l10n key naming a piece of in-app content in the web string
 * catalog. Only tree types and land skins are named there — for those
 * types the content's `value` is a gid, not an amount. Title keys
 * spell land skins `landskin`, not `land_skin` like the content type.
 */
export function contentTitleKey(
  type: ItemContent['type'],
  gid: number,
): string | null {
  switch (type) {
    case 'land_skin':
      return `landskin_${gid}_title`
    case 'tree_type':
      return `tree_type_${gid}_title`
    default:
      return null
  }
}
